import {
  useLayoutEffect,
  useRef,
  type CSSProperties,
  type ReactNode,
} from 'react';
import { useElementWidth } from '../hooks/useElementWidth';
import { useOtherInfoContext } from './OtherInfoContext';

export const FormArea = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const width = useElementWidth(ref);
  const { setFormAreaWidth } = useOtherInfoContext();

  useLayoutEffect(() => {
    setFormAreaWidth(width);
  }, [width, setFormAreaWidth]);

  return (
    <div
      ref={ref}
      style={{ width: '100%', minWidth: 0, boxSizing: 'border-box', ...style }}
    >
      {children}
    </div>
  );
};
